import {IdName} from '@domain/id-name';
import {AssertionUtils} from '@vdw/angular-component-library';

export class GroupedOrderLine {
  private _quality: IdName;
  private _colorSet: IdName;
  private _commercialWidthInCm: number;
  private _technicalWidthInDents: number;
  private _orderlineIds: number[];
  private _lengthInMM: number;
  private _lengthInPicks: number;
  private _surfaceInMM2: number;
  private _numberOfPieces: number;

  public constructor(
    quality: IdName,
    colorSet: IdName,
    commercialWidthInCm: number,
    technicalWidthInDents: number,
    orderlineIds: number[],
    lengthInMM: number,
    lengthInPicks: number,
    surfaceInMM2: number,
    numberOfPieces: number
  ) {
    this._quality = quality;
    this._colorSet = colorSet;
    this._commercialWidthInCm = commercialWidthInCm;
    this._technicalWidthInDents = technicalWidthInDents;
    this._orderlineIds = orderlineIds;
    this._lengthInMM = lengthInMM;
    this._lengthInPicks = lengthInPicks;
    this._surfaceInMM2 = surfaceInMM2;
    this._numberOfPieces = numberOfPieces;
  }

  public get quality(): IdName {
    return this._quality;
  }

  public set quality(value: IdName) {
    this._quality = value;
  }

  public get colorSet(): IdName {
    return this._colorSet;
  }

  public set colorSet(value: IdName) {
    this._colorSet = value;
  }

  public get commercialWidthInCm(): number {
    return this._commercialWidthInCm;
  }

  public set commercialWidthInCm(value: number) {
    this._commercialWidthInCm = value;
  }

  public get technicalWidthInDents(): number {
    return this._technicalWidthInDents;
  }

  public set technicalWidthInDents(value: number) {
    this._technicalWidthInDents = value;
  }

  public get orderlineIds(): number[] {
    return this._orderlineIds;
  }

  public set orderlineIds(value: number[]) {
    this._orderlineIds = value;
  }

  public get lengthInMM(): number {
    return this._lengthInMM;
  }

  public set lengthInMM(value: number) {
    this._lengthInMM = value;
  }

  public get lengthInPicks(): number {
    return this._lengthInPicks;
  }

  public set lengthInPicks(value: number) {
    this._lengthInPicks = value;
  }

  public get surfaceInMM2(): number {
    return this._surfaceInMM2;
  }

  public set surfaceInMM2(value: number) {
    this._surfaceInMM2 = value;
  }

  public get numberOfPieces(): number {
    return this._numberOfPieces;
  }

  public set numberOfPieces(value: number) {
    this._numberOfPieces = value;
  }

  public static fromJSON(groupedOrderlineJSON: any): GroupedOrderLine {
    return new GroupedOrderLine(
      groupedOrderlineJSON.quality,
      groupedOrderlineJSON.colorSet,
      !AssertionUtils.isNullOrUndefined(groupedOrderlineJSON.commercialWidthInCM) ? groupedOrderlineJSON.commercialWidthInCM : 0,
      !AssertionUtils.isNullOrUndefined(groupedOrderlineJSON.technicalWidthInDents) ? groupedOrderlineJSON.technicalWidthInDents : 0,
      groupedOrderlineJSON.orderLines.map((orderLine: any) => parseInt(orderLine.id)),
      groupedOrderlineJSON.lengthInMM,
      groupedOrderlineJSON.lengthInPicks,
      groupedOrderlineJSON.surfaceInMM2,
      groupedOrderlineJSON.numberOfPieces
    );
  }
}
